export default __webpack_public_path__ + "static/media/worms.aa47b6a7.png";